import { Controller, FieldValues, useFormContext } from 'react-hook-form';
import { CommonFieldProps } from '../form.types';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';

export type DateFieldProps<T extends FieldValues> = CommonFieldProps<T> & {
  type: 'date';
};

export const DateField = <T extends FieldValues>({
  name,
  label
}: DateFieldProps<T>) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <DatePicker
          {...field}
          value={field.value ? dayjs(field.value) : null}
          label={label}
          format="DD/MM/YYYY"
          onChange={(date) => {
            const isoDate = date ? date.toISOString() : undefined;
            field.onChange(isoDate);
          }}
        />
      )}
    />
  );
};
